import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";

interface MinimalOption {
  id: string;
  name: string;
}

interface QuestionBasicSettingsProps {
  tools?: MinimalOption[];
  questionTypes?: MinimalOption[];
  toolId: string;
  onToolChange: (value: string) => void;
  questionTypeId: string;
  onQuestionTypeChange: (value: string) => void;
  questionText: string;
  onQuestionTextChange: (value: string) => void;
}

export const QuestionBasicSettings = ({
  tools,
  questionTypes,
  toolId,
  onToolChange,
  questionTypeId,
  onQuestionTypeChange,
  questionText,
  onQuestionTextChange,
}: QuestionBasicSettingsProps) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="tool">Tool</Label>
          <Select value={toolId} onValueChange={onToolChange}>
            <SelectTrigger>
              <SelectValue placeholder="Select a tool (optional)" />
            </SelectTrigger>
            <SelectContent>
              {tools?.map((tool) => (
                <SelectItem key={tool.id} value={tool.id}>
                  {tool.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="question_type">Question Type</Label>
          <Select value={questionTypeId} onValueChange={onQuestionTypeChange}>
            <SelectTrigger>
              <SelectValue placeholder="Select question type" />
            </SelectTrigger>
            <SelectContent>
              {questionTypes?.map((type) => (
                <SelectItem key={type.id} value={type.id}>
                  {type.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="question_text">Question Text</Label>
        <Textarea
          id="question_text"
          value={questionText}
          onChange={(e) => onQuestionTextChange(e.target.value)}
          placeholder="Enter the question text..."
          rows={3}
        />
      </div>
    </div>
  );
};

export default QuestionBasicSettings;

